/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Metadata Service
 * API for managing interface-specific metadata.
 *
 * The version of the OpenAPI document: 2022-01-26
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *  - AWS_SECURITY_GROUP: If the customer indicated that the security group has been updated.
 *  - AWS_ROUTE_TABLE: If the customer indicated that the route table has been updated.
 * @export
 * @enum {string}
 */
export var HashicorpCloudMetadata20220126PeeringCompletion;
(function (HashicorpCloudMetadata20220126PeeringCompletion) {
    HashicorpCloudMetadata20220126PeeringCompletion["SECURITYGROUP"] = "AWS_SECURITY_GROUP";
    HashicorpCloudMetadata20220126PeeringCompletion["ROUTETABLE"] = "AWS_ROUTE_TABLE";
})(HashicorpCloudMetadata20220126PeeringCompletion || (HashicorpCloudMetadata20220126PeeringCompletion = {}));
export function HashicorpCloudMetadata20220126PeeringCompletionFromJSON(json) {
    return HashicorpCloudMetadata20220126PeeringCompletionFromJSONTyped(json, false);
}
export function HashicorpCloudMetadata20220126PeeringCompletionFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function HashicorpCloudMetadata20220126PeeringCompletionToJSON(value) {
    return value;
}
